import { NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import {
  LayoutDefaultWithNamedOutletsComponent
} from 'features/common/components/layout-default-with-named-outlets/layout-default-with-named-outlets.component';

@NgModule({
  providers: [
    provideRouter([
      {
        path: 'hosted-payment/:pageId',
        component: LayoutDefaultWithNamedOutletsComponent,
        data: {
          pageClass: 'hosted-payment'
        },
        children: [
          {
            path: '',
            loadComponent: () => import('features/flashpay/components/header/header.component').then((x) => x.HeaderComponent),
            outlet: 'header'
          },
          // {
          //   path: '',
          //   loadComponent: () => import('features/common/components/footer/footer.component').then((x) => x.FooterComponent),
          //   outlet: 'footer'
          // },
          {
            path: '',
            children: [
              {
                path: '',
                loadComponent: () => import('./pages/payment/payment.component').then((x) => x.PaymentComponent),
              },
              {
                path: 'result',
                loadComponent: () => import('./pages/result/result.component').then((x) => x.ResultComponent),
              }
            ]
          },

        ]
      },
    ], withComponentInputBinding()),
  ]
})
export class HostedPaymentRoutingModule { }


